module.exports = __webpack_public_path__ + "51b42257.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/global/Sidebar/static/ic_Top.png
// module id = 947
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 16